import initReactApp from 'dpl/util/initReactApp';
import FooterNewsletterForm from 'dpl/components/FooterNewsletterForm';
import PrivacyChoicesModalContainer from 'dpl/common/components/PrivacyChoicesModalContainer';

initReactApp({
  FooterNewsletterForm,
  PrivacyChoicesModalContainer
});
